import { paths } from '@/config/paths';
import { useAuthStore } from '@/stores/authStore';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

interface LogoProps extends React.HTMLAttributes<HTMLImageElement> {
  variant?: 'anchor' | 'link' | 'image';
}

const LOGO_BY_COUNTRY: Record<string, string> = {
  CA: '/assets/logo-ca.png',
  US: '/assets/logo.svg',
};

export const Logo = ({ variant = 'image', ...props }: LogoProps) => {
  const { t } = useTranslation('components', {
    keyPrefix: 'logo',
  });

  const countryCode = useAuthStore((s) => s.userData?.center.countryCode);
  const src = LOGO_BY_COUNTRY[countryCode ?? 'US'] ?? LOGO_BY_COUNTRY.US;

  const image = <img src={src} alt={t('alt')} className='h-11' {...props} />;

  switch (variant) {
    case 'link': {
      return (
        <Link to={paths.home.path} aria-label={t('link.ariaLabel')}>
          {image}
        </Link>
      );
    }
    case 'anchor': {
      return (
        <a href={paths.home.path} aria-label={t('link.ariaLabel')}>
          {image}
        </a>
      );
    }
    default: {
      return image;
    }
  }
};
